
import Page from "../component/page/Page"
import OrderConfirmationPage from "../component/orderConfirmation/OrderConfirmationPage"
import TravelDocument from "../component/travelDoc/TravelDocument"
import Test from "../component/Test"

import Country from "../component/destinations/Country"
import DestinationCollection from "../component/destinations/DestinationCollection"
import Category from "../component/categories/Category"
import CategoryCollection from "../component/categories/CategoryCollection"
import LocationPage from "../component/destinations/LocationPage"
import ContentPage from "../component/contentPages/ContentPage"

import { lazy } from "react"
const productDetailComponent=lazy(() => import('../component/productDetailPage/ProductDetail'));
const registerComponent=lazy(() => import('../component/register/Register'));
const forgotComponent=lazy(() => import('../component/forgotpassword/Forgotpassword'));
const loginComponent=lazy(() => import('../component/login/Login'));
const checkoutLayoutComponent=lazy(() => import('../component/checkout/CheckoutLayout'));
const homeLayoutComponent=lazy(() => import('../component/home/Home'));

let componentCollection = [

    {
        "component": homeLayoutComponent,
        "doctype": "home",
    },
    {
        "component": checkoutLayoutComponent,
        "doctype": "checkoutPage",
    },
    {
        "component": TravelDocument,
        "doctype": "travelDocument",
    },
    {
        "component": Page,
        "doctype": "page"
    },
    {
        "component": OrderConfirmationPage,
        "doctype": "orderPage"
    },
    {
        "component": Test,
        "doctype": "testPage"
    },
    {
        "component": productDetailComponent,
        "doctype": "productPage"
    },
    {
        "component": productDetailComponent,
        "doctype": "product"
    },
    {
        "component": DestinationCollection,
        "doctype": "destinationCollection"
    },
    {
        "component": Country,
        "doctype": "destinationCountry"
    },
    {
        "component": LocationPage,
        "doctype": "destinationLocation"
    }
    ,
    {
        "component": CategoryCollection,
        "doctype": "categoryCollection"
    },
    {
        "component": Category,
        "doctype": "category"
    },
    {
        "component": ContentPage,
        "doctype": "contentPage"
    },
    {
        "component": registerComponent,
        "doctype": "register"
    },
    {
        "component": loginComponent,
        "doctype": "login"
    },
    {
        "component": loginComponent,
        "doctype": "loginecom"
    },
    {
        "component": forgotComponent,
        "doctype": "forgotPassword"
    }
]
export const getComponent = (component) => {

    return componentCollection.find(x => x.doctype === component);

}

